import { GmUploadMaterial } from '@adCommonComponent'; //素材上传
export default {
  components: { GmUploadMaterial },
  data() {
    return {
      fileList: [],
    };
  },
  computed: {
    currentAddSaleId() {
      return this.$store.state.num.currentAddSaleId;
    },
    userInfo() {
      return this.$store.state.user.userInfo.data;
    },
    adAccountId() {
      return this.accountId || this.$store.getters.accountId;
    },
    // 保存素材的参数
    saveAdFileParam() {
      return {
        initiatorUid: this.userInfo.id,
        uid: this.userInfo.id,
        orgCode: this.userInfo.orgCode,
        saleId: this.adTypeMsg.saleId || this.currentAddSaleId, //批量编辑 || 创建
        langId: this.adTypeMsg.langId || this.adSeriesInfo?.sale?.langId || 0,
        proId: this.adTypeMsg.productId || this.adSeriesInfo?.sale?.productId || 0,
        adAccountId: this.adAccountId,
      };
    },
    // 查询广告素材库的参数
    adMaterialParams() {
      return {
        mediaType: 'IMAGE',
        platform: 'facebook',
        productId: this.adTypeMsg.productId || this.adSeriesInfo?.sale?.productId || 0,
        aid: this.adAccountId,
        adid: this.adTypeMsg?.id || '', //复制的时候没有,创建的时候没有
        lpu: this.adTypeMsg?.web_url || this.adSeriesInfo?.web_url || '',
      };
    },
  },
};
